'use strict';exports.__esModule = true;exports.searchAgencies = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _pick = require('lodash/pick');var _pick2 = _interopRequireDefault(_pick);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _constants = require('../../constants');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;
var requestRoute = '/agencies/search';
var supportedRequestKeys = ['loc', 'city', 'drawn', 'sort']; // 'limit', 'skip', neighborhood

var loadAgencySuccess = (0, _reduxAct.createAction)('/SEARCH_AGENCY_SUCCESS');
var loadAgencyFail = (0, _reduxAct.createAction)('/SEARCH_AGENCY_FAIL');
var searchAgencies = (0, _reduxAct.createAction)('/SEARCH_AGENCY');

var fetchLoad = function fetchLoad(parameters) {
  var params = (0, _pick2.default)(parameters, supportedRequestKeys);
  params = params.drawn ? params : { params: params };

  var method = parameters.drawn ? 'post' : 'get';

  return _axios2.default[method](requestRoute, params).
  then(loadAgencySuccess, loadAgencyFail);
};

var handleSearch = function handleSearch(state, _ref) {var params = _ref[0],zoom = _ref[1];
  var res = null;
  if (zoom >= _constants.zoomForAgencyPinDisplay) {
    res = (0, _reduxLoop.loop)(Object.assign({},
    state, {
      loading: true,
      params: params,
      zoom: zoom }),
    promise(fetchLoad, params, zoom));
  } else {
    res = (0, _reduxLoop.loop)(Object.assign({}, state, { data: [] }),
    promise(function () {return Promise.resolve(loadAgencySuccess({ data: [] }));}));
  }

  return res;
};


var handleLoadSuccess = function handleLoadSuccess(state, action) {return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: action.data });};


var handleLoadFail = function handleLoadFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Failed agency search');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var initialState = {
  loaded: false,
  loading: false,
  data: [] };


var agencySearch = (0, _reduxAct.createReducer)(function (on) {
  on(loadAgencySuccess, handleLoadSuccess);
  on(loadAgencyFail, handleLoadFail);
  on(searchAgencies, handleSearch);
}, initialState);exports.


searchAgencies = searchAgencies;exports.default =


agencySearch;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/agencySearch.js
// module id = 1267
// module chunks = 0